import { produce } from "immer";
import {
  FETCH_CARE_ROUND,
  FETCH_CARE_ROUND_SUCCESS,
  FETCH_CARE_ROUND_FAILURE,
  ADD_CARE_ROUND,
  ADD_CARE_ROUND_SUCCESS,
  ADD_CARE_ROUND_FAILURE,
  FETCH_CARE_ROUND_ITEM,
  FETCH_CARE_ROUND_ITEM_SUCCESS,
  FETCH_CARE_ROUND_ITEM_FAILURE,
  FETCH_CARE_ROUND_REPORT,
  FETCH_CARE_ROUND_REPORT_SUCCESS,
  FETCH_CARE_ROUND_REPORT_FAILURE,
  FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY,
  FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY_SUCCESS,
  FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY_FAILURE,
  FETCH_CARE_ROUND_OCCURRENCE_REPORT,
  FETCH_CARE_ROUND_OCCURRENCE_REPORT_SUCCESS,
  FETCH_CARE_ROUND_OCCURRENCE_REPORT_FAILURE,
  EDIT_CARE_ROUND,
  EDIT_CARE_ROUND_SUCCESS,
  EDIT_CARE_ROUND_FAILURE,
  DELETE_CARE_ROUND,
  DELETE_CARE_ROUND_SUCCESS,
  DELETE_CARE_ROUND_FAILURE,
  SET_CARE_ROUND_ADD_EDIT_MODAL,
  FETCH_FACILITY_DAILY_REPORT,
  FETCH_FACILITY_DAILY_REPORT_SUCCESS,
  FETCH_FACILITY_DAILY_REPORT_FAILURE,
  FETCH_FACILITY_TWICE_DAILY_REPORT,
  FETCH_FACILITY_TWICE_DAILY_REPORT_SUCCESS,
  FETCH_FACILITY_TWICE_DAILY_REPORT_FAILURE,
  FETCH_FACILITY_WEEKLY_REPORT,
  FETCH_FACILITY_WEEKLY_REPORT_SUCCESS,
  FETCH_FACILITY_WEEKLY_REPORT_FAILURE,
  FETCH_FACILITY_INTERVAL_REPORT,
  FETCH_FACILITY_INTERVAL_REPORT_SUCCESS,
  FETCH_FACILITY_INTERVAL_REPORT_FAILURE,
  FETCH_ROUND_ASSIGNMENT_SUMMARY,
  FETCH_ROUND_ASSIGNMENT_SUMMARY_SUCCESS,
  FETCH_ROUND_ASSIGNMENT_SUMMARY_FAILURE,
} from "./constants";

export const initialState = {
  careRoundList: [],
  currentCareRound: null,
  careRoundReport: null,
  careRoundNextTwoDaysSummary: null,
  careRoundOccurrenceReport: null,
  facilityDailyReport: null,
  careRoundTotal: 0,
  isFetchingCareRound: false,
  isFetchingCareRoundReport: false,
  isFetchingCareRoundNextTwoDaysSummary: false,
  isFetchingCareRoundOccurrenceReport: false,
  isFetchingFacilityDailyReport: false,
  roundAssignmentSummary: [],
  isFetchingRoundAssignmentSummary: false,
  isSubmittingCareRound: false,
  isDeletingCareRound: false,
  careRoundAddEditModal: { open: false, isEditing: false, item: null },
};

const CareRoundReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_CARE_ROUND: {
        draft.isFetchingCareRound = true;
        const page = action.payload?.page;
        if (page === 1 || page == null) {
          draft.careRoundList = [];
        }
        break;
      }
      case FETCH_CARE_ROUND_SUCCESS: {
        draft.isFetchingCareRound = false;
        const payload = action.payload;
        const p = payload?.current_page ?? 1;
        if (p === 1) {
          draft.careRoundList = payload;
        } else {
          const prevData = Array.isArray(draft.careRoundList?.data)
            ? draft.careRoundList.data
            : [];
          const nextData = Array.isArray(payload?.data) ? payload.data : [];
          draft.careRoundList = {
            ...payload,
            data: [...prevData, ...nextData],
            current_page: p,
          };
        }
        draft.careRoundTotal = payload?.total ?? draft.careRoundTotal ?? 0;
        break;
      }
      case FETCH_CARE_ROUND_FAILURE:
        draft.isFetchingCareRound = false;
        draft.careRoundList = [];
        break;

      case ADD_CARE_ROUND:
        draft.isSubmittingCareRound = true;
        break;
      case ADD_CARE_ROUND_SUCCESS:
        draft.isSubmittingCareRound = false;
        break;
      case ADD_CARE_ROUND_FAILURE:
        draft.isSubmittingCareRound = false;
        break;

      case FETCH_CARE_ROUND_ITEM:
        draft.isFetchingCareRound = true;
        draft.currentCareRound = null;
        break;
      case FETCH_CARE_ROUND_ITEM_SUCCESS:
        draft.isFetchingCareRound = false;
        draft.currentCareRound = action.payload;
        break;
      case FETCH_CARE_ROUND_ITEM_FAILURE:
        draft.isFetchingCareRound = false;
        draft.currentCareRound = null;
        break;

      case FETCH_CARE_ROUND_REPORT:
        draft.isFetchingCareRoundReport = true;
        draft.careRoundReport = null;
        break;
      case FETCH_CARE_ROUND_REPORT_SUCCESS:
        draft.isFetchingCareRoundReport = false;
        draft.careRoundReport = action.payload;
        break;
      case FETCH_CARE_ROUND_REPORT_FAILURE:
        draft.isFetchingCareRoundReport = false;
        draft.careRoundReport = null;
        break;

      case FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY:
        draft.isFetchingCareRoundNextTwoDaysSummary = true;
        draft.careRoundNextTwoDaysSummary = null;
        break;
      case FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY_SUCCESS:
        draft.isFetchingCareRoundNextTwoDaysSummary = false;
        draft.careRoundNextTwoDaysSummary = action.payload;
        break;
      case FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY_FAILURE:
        draft.isFetchingCareRoundNextTwoDaysSummary = false;
        draft.careRoundNextTwoDaysSummary = null;
        break;

      case FETCH_CARE_ROUND_OCCURRENCE_REPORT:
        draft.isFetchingCareRoundOccurrenceReport = true;
        draft.careRoundOccurrenceReport = null;
        break;
      case FETCH_CARE_ROUND_OCCURRENCE_REPORT_SUCCESS:
        draft.isFetchingCareRoundOccurrenceReport = false;
        draft.careRoundOccurrenceReport = action.payload;
        break;
      case FETCH_CARE_ROUND_OCCURRENCE_REPORT_FAILURE:
        draft.isFetchingCareRoundOccurrenceReport = false;
        draft.careRoundOccurrenceReport = null;
        break;

      case EDIT_CARE_ROUND:
        draft.isSubmittingCareRound = true;
        break;
      case EDIT_CARE_ROUND_SUCCESS:
        draft.isSubmittingCareRound = false;
        break;
      case EDIT_CARE_ROUND_FAILURE:
        draft.isSubmittingCareRound = false;
        break;

      case DELETE_CARE_ROUND:
        draft.isDeletingCareRound = true;
        break;
      case DELETE_CARE_ROUND_SUCCESS:
        draft.isDeletingCareRound = false;
        break;
      case DELETE_CARE_ROUND_FAILURE:
        draft.isDeletingCareRound = false;
        break;

      case SET_CARE_ROUND_ADD_EDIT_MODAL:
        draft.careRoundAddEditModal = {
          open: action.payload?.open ?? false,
          isEditing: action.payload?.isEditing ?? false,
          item: action.payload?.item ?? null,
        };
        break;

      case FETCH_FACILITY_DAILY_REPORT:
        if (!action.payload?.silent) {
          draft.isFetchingFacilityDailyReport = true;
          draft.facilityDailyReport = null;
        }
        break;
      case FETCH_FACILITY_DAILY_REPORT_SUCCESS:
        draft.isFetchingFacilityDailyReport = false;
        draft.facilityDailyReport = action.payload;
        break;
      case FETCH_FACILITY_DAILY_REPORT_FAILURE:
        draft.isFetchingFacilityDailyReport = false;
        draft.facilityDailyReport = null;
        break;

      case FETCH_FACILITY_TWICE_DAILY_REPORT:
        if (!action.payload?.silent) {
          draft.isFetchingFacilityTwiceDailyReport = true;
          draft.facilityTwiceDailyReport = null;
        }
        break;
      case FETCH_FACILITY_TWICE_DAILY_REPORT_SUCCESS:
        draft.isFetchingFacilityTwiceDailyReport = false;
        draft.facilityTwiceDailyReport = action.payload;
        break;
      case FETCH_FACILITY_TWICE_DAILY_REPORT_FAILURE:
        draft.isFetchingFacilityTwiceDailyReport = false;
        draft.facilityTwiceDailyReport = null;
        break;

      case FETCH_FACILITY_WEEKLY_REPORT:
        if (!action.payload?.silent) {
          draft.isFetchingFacilityWeeklyReport = true;
          draft.facilityWeeklyReport = null;
        }
        break;
      case FETCH_FACILITY_WEEKLY_REPORT_SUCCESS:
        draft.isFetchingFacilityWeeklyReport = false;
        draft.facilityWeeklyReport = action.payload;
        break;
      case FETCH_FACILITY_WEEKLY_REPORT_FAILURE:
        draft.isFetchingFacilityWeeklyReport = false;
        draft.facilityWeeklyReport = null;
        break;

      case FETCH_FACILITY_INTERVAL_REPORT:
        if (!action.payload?.silent) {
          draft.isFetchingFacilityIntervalReport = true;
          draft.facilityIntervalReport = null;
        }
        break;
      case FETCH_FACILITY_INTERVAL_REPORT_SUCCESS:
        draft.isFetchingFacilityIntervalReport = false;
        draft.facilityIntervalReport = action.payload;
        break;
      case FETCH_FACILITY_INTERVAL_REPORT_FAILURE:
        draft.isFetchingFacilityIntervalReport = false;
        draft.facilityIntervalReport = null;
        break;

      case FETCH_ROUND_ASSIGNMENT_SUMMARY:
        draft.isFetchingRoundAssignmentSummary = true;
        draft.roundAssignmentSummary = [];
        break;
      case FETCH_ROUND_ASSIGNMENT_SUMMARY_SUCCESS:
        draft.isFetchingRoundAssignmentSummary = false;
        draft.roundAssignmentSummary = Array.isArray(action.payload)
          ? action.payload
          : [];
        break;
      case FETCH_ROUND_ASSIGNMENT_SUMMARY_FAILURE:
        draft.isFetchingRoundAssignmentSummary = false;
        draft.roundAssignmentSummary = [];
        break;

      default:
        break;
    }
  });

export default CareRoundReducer;
